/* eslint-disable react/display-name */
import React, { useEffect, Suspense, lazy, useState, useReducer } from 'react'
import Sidebar from './Sidebar'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import SuspenseLoader from 'components/suspense_loader/SuspenseLoader'
import { getStatsUrl } from 'utils/js/endpoints'
import { fetchDataWithHooks } from 'utils/js/fetch_helpers'
import { slugMap } from './ancillaryHelpers'
import HeaderTitle from 'containers/shared/HeaderTitle'

import './AncillaryLeague.scss'
import { preserveQueryParams } from 'utils/js/browser_helpers'

const AncillaryRankings = lazy(() => import('./pages/AncillaryRankings'))
const AncillaryResults = lazy(() => import('./pages/AncillaryResults'))
const AncillarySchedule = lazy(() => import('./pages/AncillarySchedule'))
const AncillaryEvent = lazy(() => import('./pages/AncillaryEvent'))

export default function AncillaryLeague(props) {
    const { sport, league, page, id } = props.match.params

    let tabsAndPageData = generateLinkingTabData(sport, league, page, id)
    let pageTitle = generateLeaguePageTitle(league)
    let activeIndex = tabsAndPageData.findIndex(item => item.active)

    return (
        <div className="AncillaryLeague__cont">
            <div className="inner_cont">
                <div className="left_col">
                    <HeaderTitle title={pageTitle} />

                    <TabsAndPages
                        initStateData={{
                            activeIndex: activeIndex,
                            endpointData: {},
                            initLoad: true,
                        }}
                        pageData={tabsAndPageData}
                    />
                </div>

                <div className="right_col">
                    <Sidebar league={league} />
                </div>
            </div>
        </div>
    )
}

const generateLinkingTabData = (sport = '', league = '', page = '', id = '') => {
    if (!sport || !league || !page) return []

    let stats_slug = slugMap(league)
    let currentYear = new Date().getFullYear()

    let statsLeague
    if (stats_slug === 'champions') {
        statsLeague = 'champ'
    } else if (stats_slug === 'european') {
        statsLeague = 'eurogolf'
    } else {
        statsLeague = stats_slug
    }

    let events_endpoint = `${getStatsUrl()}/events/${league}/${id}`

    if (sport === 'auto-racing') {
        events_endpoint = `${getStatsUrl()}/tournament_schedule?league=${stats_slug}&season_year=${currentYear}&id=${id}`
    } else if (sport === 'golf' || sport === 'tennis') {
        events_endpoint = `${getStatsUrl()}/tournament_schedule?league=${statsLeague}&id=${id}`
    }

    let tabsAndPageData

    if (
        sport === 'golf' &&
        (league === 'lpga' || league === 'champions' || league === 'european')
    ) {
        tabsAndPageData = [
            {
                display_name: 'Schedule',
                page: 'schedule',
                sport: sport,
                league: league,
                active: page === 'schedule',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/${
                    sport === 'tennis' || sport === 'golf' ? 'tournament_schedule' : 'events'
                }?league=${statsLeague}`,
                component: props => <AncillarySchedule league={league} sport={sport} {...props} />,
            },
            {
                display_name: 'Results',
                page: 'results',
                sport: sport,
                league: league,
                active: page === 'results',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/${
                    sport === 'tennis' || sport === 'golf' ? 'tournament_schedule' : 'tournaments'
                }?league=${statsLeague}`,
                component: props => <AncillaryResults league={league} sport={sport} {...props} />,
            },
            {
                display_name: 'Events',
                page: 'events',
                sport: sport,
                league: league,
                active: page === 'events',
                show_tab: false,
                init_endpoint: events_endpoint,
                component: props => <AncillaryEvent sport={sport} league={league} {...props} />,
            },
        ]
    } else if (sport === 'auto-racing') {
        tabsAndPageData = [
            {
                display_name: 'Schedule',
                page: 'schedule',
                sport: sport,
                league: league,
                active: page === 'schedule',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/tournament_schedule?league=${statsLeague}&season_year=${currentYear}`,
                component: props => <AncillarySchedule league={league} sport={sport} {...props} />,
            },
            {
                display_name: 'Results',
                page: 'results',
                sport: sport,
                league: league,
                active: page === 'results',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/tournament_schedule?league=${statsLeague}&season_year=${currentYear}`,
                component: props => <AncillaryResults league={league} sport={sport} {...props} />,
            },
            {
                display_name: 'Rankings',
                page: 'rankings',
                sport: sport,
                league: league,
                active: page === 'rankings',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/tournament_rankings?league=${statsLeague}&season_year=${currentYear}`,
                component: props => <AncillaryRankings sport={sport} league={league} {...props} />,
            },
            {
                display_name: 'Events',
                page: 'events',
                sport: sport,
                league: league,
                active: page === 'events',
                show_tab: false,
                init_endpoint: events_endpoint,
                component: props => <AncillaryEvent sport={sport} league={league} {...props} />,
            },
        ]
    } else {
        tabsAndPageData = [
            {
                display_name: 'Schedule',
                page: 'schedule',
                sport: sport,
                league: league,
                active: page === 'schedule',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/${
                    sport === 'tennis' || sport === 'golf' ? 'tournament_schedule' : 'events'
                }?league=${statsLeague}`,
                component: props => <AncillarySchedule league={league} sport={sport} {...props} />,
            },
            {
                display_name: 'Results',
                page: 'results',
                sport: sport,
                league: league,
                active: page === 'results',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/${
                    sport === 'tennis' || sport === 'golf' ? 'tournament_schedule' : 'tournaments'
                }?league=${statsLeague}`,
                component: props => <AncillaryResults league={league} sport={sport} {...props} />,
            },
            {
                display_name: 'Rankings',
                page: 'rankings',
                sport: sport,
                league: league,
                active: page === 'rankings',
                show_tab: true,
                init_endpoint: `${getStatsUrl()}/${
                    sport === 'tennis' || sport === 'golf' ? 'tournament_rankings' : 'standings'
                }?league=${statsLeague}&season=${currentYear}`,
                component: props => <AncillaryRankings sport={sport} league={league} {...props} />,
            },
            {
                display_name: 'Events',
                page: 'events',
                sport: sport,
                league: league,
                active: page === 'events',
                show_tab: false,
                init_endpoint: events_endpoint,
                component: props => <AncillaryEvent sport={sport} league={league} {...props} />,
            },
        ]
    }

    return tabsAndPageData
}

function stateReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_POST_FETCH_STATE':
            return {
                activeIndex: action.activeIndex,
                endpointData: action.endpointData,
                initLoad: false,
            }
        default:
            throw new Error()
    }
}

const TabsAndPages = ({ initStateData = {}, pageData = {} }) => {
    const [state, dispatch] = useReducer(stateReducer, initStateData)
    const [isError, setError] = useState(false)
    const [isFetching, setFetching] = useState(true)

    let newActiveIndex = null
    pageData.forEach((item, i) => {
        if (item.active === true) newActiveIndex = i
    })

    const shownTabsDataLength = pageData.filter(item => item.show_tab === true).length
    const showTabbingAnimation = newActiveIndex < shownTabsDataLength

    const activeTabPosition = showTabbingAnimation ? 100 * newActiveIndex : 0
    const activeTabWidth = showTabbingAnimation ? 100 / shownTabsDataLength : 0
    const activeTabOpacity = showTabbingAnimation ? 1 : 0

    const ActiveComponent = pageData[state.activeIndex].component

    const setNewData = arg => {
        let activeIndex = null
        pageData.forEach((item, i) => {
            if (item.active === true) activeIndex = i
        })

        dispatch({
            type: 'UPDATE_POST_FETCH_STATE',
            activeIndex: activeIndex,
            endpointData: arg,
            initLoad: false,
        })
    }

    useEffect(() => {
        setFetching(true)

        fetchDataWithHooks(
            pageData[newActiveIndex].init_endpoint,
            setNewData,
            setFetching,
            setError
        )
    }, [newActiveIndex + pageData[newActiveIndex].init_endpoint])

    useEffect(() => {
        let links = document.querySelectorAll('.ripple_tab_link')

        for (var i = 0, len = links.length; i < len; i++) {
            links[i].addEventListener(
                'click',
                function(e) {
                    let targetEl = e.target
                    let inkEl = targetEl.querySelector('.ink')

                    if (inkEl) {
                        inkEl.classList.remove('animate_ripple')
                    } else {
                        inkEl = document.createElement('span')
                        inkEl.classList.add('ink')
                        inkEl.style.width = inkEl.style.height =
                            Math.max(targetEl.offsetWidth, targetEl.offsetHeight) + 'px'
                        targetEl.appendChild(inkEl)
                    }

                    inkEl.style.left = e.offsetX - inkEl.offsetWidth / 2 + 'px'
                    inkEl.style.top = e.offsetY - inkEl.offsetHeight / 2 + 'px'
                    inkEl.classList.add('animate_ripple')
                },
                false
            )
        }
    }, [])

    if (isError) {
        return (
            <div className="AncillaryLeague__cont">
                Unfortunately, An Error Has Occurred. Please Try Again.
            </div>
        )
    }

    return (
        <React.Fragment>
            <div className="tabs_cont" id="tabs_cont">
                <div
                    className="active_tab_slider"
                    style={{
                        transform: `translate3d(${activeTabPosition}%, 0, 0)`,
                        width: `${activeTabWidth}%`,
                        opacity: activeTabOpacity,
                    }}
                ></div>

                <div className="tabs_cont_inner">
                    {pageData.map((item, i) => (
                        <React.Fragment key={item.page_name + i.toString()}>
                            {item.active && <PageHelmet {...item} />}
                            {item.show_tab && (
                                <div className={`tab_cont ${item.active ? 'active' : ''}`}>
                                    <div
                                        className={`ripple_tab_link tab_cont_inner ${(item.active &&
                                            'active') ||
                                            ''}`}
                                    >
                                        <Link
                                            to={preserveQueryParams(
                                                `/${item.sport}/${item.league}/${item.page}`
                                            )}
                                        >
                                            {item.display_name}
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            {!state.initLoad && (
                <Suspense fallback={<SuspenseLoader />}>
                    <ActiveComponent data={state.endpointData} isFetching={isFetching} />
                </Suspense>
            )}
        </React.Fragment>
    )
}

const PageHelmet = ({ sport = '', league = '', page = '', display_name = '' }) => {
    return (
        <Helmet
            title={`${league.toUpperCase()} ${display_name} - Sportsnet.ca`}
            link={[
                {
                    rel: 'canonical',
                    href: `${window.location.origin}/${sport}/${league}/${page}`,
                },
            ]}
        />
    )
}

const generateLeaguePageTitle = (league = '') => {
    if (league === 'pga') {
        return 'PGA Tour'
    } else if (league === 'lpga') {
        return 'LPGA Tour'
    } else if (league === 'champions') {
        return 'Champions Tour'
    } else if (league === 'european') {
        return 'DP World Tour'
    } else if (league === 'atp') {
        return 'ATP Tour'
    } else if (league === 'wta') {
        return 'WTA Tour'
    } else if (league === 'nascar-cup') {
        return 'NASCAR Cup'
    } else if (league === 'nascar-xfinity') {
        return 'NASCAR Xfinity'
    } else if (league === 'formula-1') {
        return 'Formula 1'
    } else if (league === 'ntt-indy-car') {
        return 'NTT IndyCar'
    }
    return ''
}
